import React from 'react';
import styles from './button.module.css';

export default ({As = 'span', children, ...rest}) =>
	<As className={styles.button} {...rest}>
		{children}
	</As>;